// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__YNnwz","tab":"ProcedureTabs_tab__1lHO5"};